import { render, staticRenderFns } from "./MultiPageShell.vue?vue&type=template&id=575abdeb&scoped=true"
import script from "./MultiPageShell.vue?vue&type=script&lang=js"
export * from "./MultiPageShell.vue?vue&type=script&lang=js"
import style0 from "./MultiPageShell.vue?vue&type=style&index=0&id=575abdeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575abdeb",
  null
  
)

export default component.exports